// The table displays dotted dimension names with '$' separators for react-base-table.
export function filterRows<T extends Record<string, unknown>>(
  rows: T[],
  searches: Record<string, string>,
) {
  const active = Object.entries(searches).filter(([, value]) => value !== '');
  return rows.filter((row) =>
    active.every(([key, value]) => {
      const cell = row[key.replace(/\$/g, '.')];
      return cell != null && String(cell).toLowerCase().includes(value.toLowerCase());
    }),
  );
}
